import React, { useState, useEffect } from "react";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import aictia from "../../../const/api";
import { notify } from "../../../redux/actions";
import { connect } from "react-redux";
import {
  CloseOutlined,
  EyeOutlined,
  SyncOutlined,
  ClearOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Modal, Typography, Button, Form, DatePicker, Select, Row, Col } from "antd";

const { Title, Text } = Typography;

const HistoryLogsModal = ({ open, companyId, companyName, onClose }) => {
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [user, setUser] = useState([]);
  const [filter, setFilter] = useState({});
  const getUser = () => {
    aictia.get("User").then((res) => {
      setUser(res.data);
    });
  };

  useEffect(() => {
    if (open) {
      getUser();
      getHistory();
    }
  }, [open]);

  const getHistory = (currentFilter = filter) => {
    const params = {
      companyId,
      PerDataCount: 0,
      GetDataCount: 100,
      ...currentFilter,
    };

    setLoading(true);

    aictia
      .get("HistoryOfCompany", { params })
      .then((res) => {
        setLogs(
          res.data.data.map((d, index) => ({
            ...d,
            key: index + 1,
            index,
          }))
        );
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSearch = (values) => {
    const params = {
      fullname: values.fullname,
      StartDate:
        values.StartDate &&
        values.StartDate[0].format("YYYY-MM-DD"),
      EndDate:
        values.StartDate &&
        values.StartDate[1].format("YYYY-MM-DD"),
    };

    setFilter(params);
    getHistory(params);
  };

  const clearFilter = () => {
    form.resetFields();
    setFilter({});
    getHistory({});
  };

  const getStyle = (operation) => {
    switch (operation) {
      case "Yaradıldı":
        return {
          background: "#ecfdf5",
          border: "#86efac",
          color: "#16a34a",
        };

      case "Redaktə edildi":
        return {
          background: "#fffbeb",
          border: "#fcd34d",
          color: "#d97706",
        };

      case "Status təsdiqləndi":
        return {
          background: "#eff6ff",
          border: "#93c5fd",
          color: "#2563eb",
        };

      case "Silindi":
        return {
          background: "#fef2f2",
          border: "#fca5a5",
          color: "#dc2626",
        };

      default:
        return {
          background: "#f8fafc",
          border: "#cbd5e1",
          color: "#64748b",
        };
    }
  };
  const getIcon = (name, color) => {
    switch (name) {
      case "Yaradıldı":
        return <CheckCircleOutlined style={{ color }} />;

      case "Redaktə edildi":
        return <EditOutlined style={{ color }} />;

      case "Status təsdiqləndi":
        return <EyeOutlined style={{ color }} />;

      case "Silindi":
        return <DeleteOutlined style={{ color }} />;

      default:
        return <SyncOutlined style={{ color }} />;
    }
  };


  const recovery = (id) => {

    aictia
      .put(`HistoryOfCompany?id=${id}`)
      .then(() => {

        notify("Bərpa edildi", true);

        getHistory();

      });

  }

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      closable={false}
      bodyStyle={{
        padding: 0,
        borderRadius: 20,
        maxHeight: "100vh",
        overflowY: "auto",
      }}
    >
      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={onClose}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          borderRadius: "50%",
          color: "#94a3b8",
        }}
      />

      <Title
        level={5}
        style={{
          paddingTop: 10,
          marginBottom: 20,
          paddingBottom: 12,
          borderBottom: "1px solid #f1f5f9",
          fontWeight: 800,
        }}
      >
        🕒 Sistem Jurnalı - {companyName}
      </Title>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSearch}
        style={{ padding: "16px 24px" }}
      >
        <Row gutter={12}>
          <Col span={10}>
            <Form.Item name="StartDate">
              <RangePicker
                style={{ width: "100%", borderRadius: 12 }}
                placeholder={["Başlanğıc", "Son"]}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="fullname">
              <Select
              className="custom-select"
                allowClear
                placeholder="İstifadəçi"
              >
                {user.map((u) => (
                  <Option
                    key={u.id}
                    value={u.fullName}
                  >
                    {u.fullName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Button
              type="primary"
              htmlType="submit"
              block
              type="primary"
              size={"large"}
              className="w-100"
              htmlType="submit"
              style={{borderRadius: 12}}
            >
              Axtar
            </Button>
          </Col>

          <Col span={3}>
            <Button
              block
              onClick={clearFilter}
              type="primary"
              size={"large"}
              className="w-100"
              htmlType="submit"
              style={{borderRadius: 12}}
            >
              <ClearOutlined />
            </Button>
          </Col>
        </Row>
      </Form>

      <div
        style={{
          overflowY: "auto",
          paddingRight: 4,
          marginTop: 10
        }}
      >
        {logs.map((item, index) => {
          const style = getStyle(item.operationName);
          return (
            <div
              key={item.id}
              style={{
                display: "flex",
                gap: 14,
                position: "relative",
                paddingBottom: 15,
              }}
            >
              {index !== logs.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    left: 9,
                    top: 22,
                    bottom: 0,
                    width: 2,
                    background: "#e2e8f0",
                  }}
                />
              )}

              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  background: style.background,
                  border: `1px solid ${style.border}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                {getIcon(item.operationName, style.color)}
              </div>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    display: "block",
                    fontSize: 10,
                    color: "#94a3b8",
                    fontFamily: "monospace",
                    fontWeight: 700,
                  }}
                >
                  {moment(item.operationDate).format("DD.MM.YYYY HH:mm")}
                </Text>

                <Text
                  strong
                  style={{
                    display: "block",
                    marginTop: 2,
                    fontSize: 12,
                    color: "#1e293b",
                  }}
                >
                  [{item.operationName}]
                </Text>

                <Text
                  style={{
                    display: "block",
                    marginTop: 4,
                    fontSize: 11,
                    color: "#64748b",
                    lineHeight: 1.5,
                  }}
                >
                  Əməliyyat aparan:{" "}
                  <span
                    style={{
                      fontWeight: 700,
                      color: "#334155",
                    }}
                  >
                    {item.fullName}
                  </span>{" "}
                  ({item.roleName})
                </Text>
                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    alignItems: "center",
                  }}
                >

                  {item.canRecovery && (
                    <Tooltip title="Bərpa">
                      <Button
                        type="text"
                        shape="circle"
                        icon={<SyncOutlined />}
                        onClick={() => recovery(item.id)}
                      />
                    </Tooltip>
                  )}

                  <Tooltip title="Ətraflı bax">
                    <Link
                      to={`/register/history/${companyId}/view/${item.id}`}
                    >
                      <Button
                        type="text"
                        shape="circle"
                        icon={<EyeOutlined />}
                      />
                    </Link>
                  </Tooltip>

                </div>
              </div>
            </div>
          )
        })}
      </div>

      <div
        style={{
          marginTop: 24,
          paddingTop: 16,
          borderTop: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button type="primary" style={{borderRadius: 12}} onClick={onClose}>
          Bağla
        </Button>
      </div>
    </Modal>
  );
};

export default HistoryLogsModal;